  document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.Card_list_main_new[data-job-url]');

    const currentUrl = window.location.pathname.replace(/\/+$/, '').toLowerCase();

    const usedUrls = new Set();

    cards.forEach(function (card) {
      let cardUrl = card.getAttribute('data-job-url');

      if (!cardUrl || cardUrl.trim() === '') {
        card.remove();
        return;
      }

      cardUrl = cardUrl.trim().replace(/\/+$/, '').toLowerCase();

      if (cardUrl === currentUrl) {
        card.remove();
        return;
      }

      if (usedUrls.has(cardUrl)) {
        card.remove();
        return;
      }

      usedUrls.add(cardUrl);
    });
  });